import React from "react";
import {Box, Switch} from "@mui/material";
import {useDispatch, useSelector} from "react-redux";
import _ from "lodash";
import styles from "../../organizationMainStyles";
import {accessibilityMode} from "../organizationSettingsConstants";
import {buildPayAgentOnSkipPayload, buildUpdateMobileHidePayload} from "../organizationSettingsUtils";
import {SnackBar} from "../../../../../common";
import {organizationSettingsActions} from "_actions";

const TEAMS_SETTING_TOGGLES = [
    {key: 'hideInMobile', labelKey: 'HIDE_IN_MOBILE', buildPayload: buildUpdateMobileHidePayload},
    {key: 'payAgentOnSkip', labelKey: 'PAY_AGENT_ON_SKIP', buildPayload: buildPayAgentOnSkipPayload},
];

export default function TeamsSettingsTogglesContainer({mode, organization, label}) {
    const disable = mode === accessibilityMode.READ_ONLY;
    const organizationId = _.get(organization, 'id');
    const dispatch = useDispatch();
    const organizationSettings = useSelector(state => state.organizationSettings);
    const organizationAttributeUpdate = organizationSettings.organizationAttributeUpdate || {};
    const loading = organizationSettings.loadingOrganizationAttributeUpdate;
    const updatingField = loading
        ? Object.keys(_.get(organizationSettings, 'payloadRef.payload', {}))[0]
        : null;

    const getValue = (key) => organizationAttributeUpdate[key] ?? _.get(organization, key);

    const handleToggle = (key, buildPayload) => (event) => {
        const value = _.get(event, 'target.checked');
        const payload = buildPayload(value);
        if (!organizationId || !payload) {
            return SnackBar.showMessage('Invalid parameters');
        }
        dispatch(organizationSettingsActions.updateOrganizationAttribute(organizationId, payload));
    };

    return (
        <Box sx={style.toggles}>
            {TEAMS_SETTING_TOGGLES.map((setting) => (
                <Box key={setting.key} sx={styles.notificationToggleContainer}>
                    <Box component="span" sx={styles.notificationToggleLabel}>
                        {label[setting.labelKey]}
                    </Box>
                    <Switch
                        disabled={disable || updatingField === setting.key}
                        checked={Boolean(getValue(setting.key))}
                        onChange={handleToggle(setting.key, setting.buildPayload)}
                        sx={styles.switch}
                    />
                </Box>
            ))}
        </Box>
    );
}

const style = {
    toggles: {
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
    },
};
